import React from "react";

export default function ResultCount(props) {

    const { resultsCountLabel,
        resultsCount } = props;

    return (
        <p className="dashboard-count"><strong>{resultsCount}</strong>{` ${resultsCountLabel}`}</p>
    );
}